<template>
  <div class="header-container">
    <div>HEXU</div>
    <div class="line-prop-container">
      <div class="menu-item">
        <div class="menu-label">管道样式</div>
        <el-select :label="item.value" v-model="item.value" v-for="item in lineProp" placeholder="请选择" size="mini"
          :key="item.label" @change="changeLineProp(item)" class="menu-select">
          <el-option v-for="item2 in item.options" :key="item2.value" :label="item2.label" :value="item2.value">
            <span style="float: left; margin-right: 10px" :class="item2.icon" class="iconfont"></span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{
              item2.label
            }}</span>
          </el-option>
        </el-select>
      </div>

      <div class="menu-item">
        <div class="menu-label">管道宽度</div>
        <el-input class="menu-select" v-model="lineWidth" @change="setLineWidth(lineWidth)" size="mini"
          placeholder="请输入内容"></el-input>
      </div>
    </div>
    <div>
      <el-button size="mini" type="text" icon="el-icon-cloudy" @click="cloudConfigVisible = true"
        title="已保存到云端的文件记录">云端</el-button>
      <el-button size="mini" type="text" icon="el-icon-download" @click="exportConfig()"
        title="导出配置文件到本地或云端">保存</el-button>
      <el-button size="mini" type="text" icon="el-icon-upload2" @click="importConfig()" title="导入配置文件">导入</el-button>

      <el-button size="mini" type="text" icon="el-icon-delete" @click="$emit('clear')"
        title="清空舞台画布当前编辑的所有内容">清空</el-button>
      <el-button size="mini" type="text" icon="el-icon-set-up" @click="previewInPage" title="切换编辑换预览模式">{{ !locked ?
        "编辑" : "预览" }}</el-button>
      <el-button size="mini" type="text" icon="el-icon-s-promotion" @click="preview" title="新窗口打开预览">预览</el-button>
      <el-dropdown>
        <el-button size="mini" type="text" title="更多选项" style="margin-left: 20px">更多<i
            class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <el-button size="mini" type="text" icon="el-icon-files" @click="versionManagemenVisible = true"
              title="每个保存文件的历史记录">版本</el-button></el-dropdown-item>
          <el-dropdown-item><el-button size="mini" type="text" icon="el-icon-time" @click="dialogFormVisible = true"
              title="只记录每个设备最新的文件记录">记录</el-button></el-dropdown-item>
          <el-dropdown-item><el-button size="mini" type="text" icon="el-icon-time"
              @click="settingGlobal">全局设置</el-button></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 最新的记录 -->
    <el-dialog title="已保存的配置" :modal="true" :visible.sync="dialogFormVisible" :modal-append-to-body="false">
      <div class="config-item" v-for="(item, key) in configs" :key="key">
        <div>{{ key }}</div>
        <el-button size="mini" @click="loadConfigFile(item)">载入</el-button>
      </div>
    </el-dialog>

    <!-- 云端文件管理 -->
    <el-dialog title="云端文件" :modal="false" :visible.sync="cloudConfigVisible" :modal-append-to-body="false">
      <div class="config-content">
        <div class="list-item" v-for="item in configList">
          <div class="left-item-card">
            <div class="name">
              <span style="margin-right: 20px">文件名：{{ item.name }} </span>
              Key：<span style="
                  font-weight: 700;
                  color: #cc6666;
                  text-decoration: underline;
                ">{{ item.key }}</span>
            </div>
            <div class="time">
              <span style="margin-right: 20px">设备类型：<span>{{
                item.typeData.typeName
              }}</span>
              </span>
            </div>
            <div class="time">
              <span>创建时间：{{ item.createTime | formatTime }}</span>
              <span>更新时间：{{
                (item.modifyTime || item.createTime) | formatTime
              }}</span>
              <span>创建人：{{ item.create | hideString }}</span>
            </div>
          </div>

          <div class="btns">
            <el-button size="mini" @click="editConfig(item)">编辑</el-button>
            <el-button size="mini" type="info" @click="deleteConfig(item)">删除</el-button>
            <el-button size="mini" type="primary" @click="downloadConfig(item)">下载</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 版本管理 -->
    <el-dialog title="历史版本管理" :modal="false" :visible.sync="versionManagemenVisible" :modal-append-to-body="false">
      <div class="config-content">
        <el-collapse accordion>
          <el-collapse-item :title="key + ' | ' + item[0].deviceName" :key="key" v-for="(item, key) in versionList">
            <div class="version-item">
              <div class="list-item" v-for="(item2, index) in item" :key="index">
                <div class="left-item-card">
                  <div class="name">
                    <span style="margin-right: 10px; color: #999">{{
                      item.length - index
                    }}</span>
                    <span style="margin-right: 20px">设备名：{{ item2.deviceName }}
                    </span>
                    <span style="margin-right: 20px">设备编号：{{ item2.deviceNo }}
                    </span>
                  </div>

                  <div class="time">
                    <span style="margin-right: 20px">修改日期：<span style="color: #008585">{{
                      item2.time | formatTime
                    }}</span>
                    </span>
                  </div>
                </div>

                <div class="btns">
                  <el-button size="mini" @click="editHistory(item2)">编辑</el-button>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { propsTypes } from "./types/sprite-types";
import Core from "@/libs/src/core.js";
import DownloadFile from "./utils/downloadFile";
export default {
  data() {
    return {
      propsTypes: propsTypes,
      lineWidth: 1,
      locked: 0,
      dialogFormVisible: false,
      cloudConfigVisible: false,
      versionManagemenVisible: false,
      configList: [],
      versionList: {}, //版本列表
      lineProp: [
        {
          icon: "icon-map-link-full",
          label: "终点",
          key: propsTypes.eumn,
          value: 0,
          options: [
            {
              label: "曲线",
              icon: "icon-quxian",
              value: "curve",
            },
            {
              label: "折线",
              icon: "icon-zhexian",
              value: "polyline",
            },
            {
              label: "直线",
              icon: "icon-zhixian",
              value: "line",
            },
            {
              label: "曲线2",
              icon: "icon-byangtiaoquxian",
              value: "mind",
            },
          ],
        },
      ],
      configs: {},
      cloudFileCategory: [],
    };
  },
  watch: {
    async dialogFormVisible(val) {
      if (val) {
        this.configs = await this.topo.getConfigAll();
      }
    },
    cloudConfigVisible(val) {
      if (val) {
        this.init();
      }
    },
    versionManagemenVisible(val) {
      if (val) {
        this.loadVersion();
      }
    },
  },
  filters: {
    // 格式化时间
    formatTime(time) {
      // 格式化时间
      const date = new Date(time);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")} ${String(
        date.getHours()
      ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
    },
    // 隐藏字符串中间四位
    hideString(str) {
      return str.replace(str.slice(3, 7), "****");
    },
  },
  async created() {
    this.topo = Core.providers.get(Core.providerTypes.TechnologyTopo); //Core.getProvider("TechnologyTopo");
    this.init();
    this.loadVersion();
    this.configs = await this.topo.getConfigAll();

  },
  methods: {
    settingGlobal() {
      this.$Application.run("xbt-setting-view");
    },
    // 编辑配置文件
    editConfig(item) {
      this.$alert(
        "这将下载云端文件覆盖当前本地正在编辑的文件，是否确认？"
      ).then((_) => {
        // 设置编辑的数据
        this.topo.proc.setData({
          editConfig: item,
        });
        this.cloudConfigVisible = false;
      });
    },
    // 删除配置文件
    deleteConfig(item) {
      this.$alert("确认删除 （"+item.name+"）？").then((_) => {
        this.$alert("确认删除将无法找回，是否确认删除？").then(_ => {
          this.topo.TopoComponents.delPagesCloud(item.id)
            .then((res) => {
              this.$message.success(res.message);
              this.init();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        })
      });
    },
    // 编辑历史文件
    editHistory(item) {
      console.log(item);
      this.$alert("是否导入历史记录文件，这将覆盖当前编辑的文件？").then(() => {
        this.topo.stageCanvas.open(JSON.parse(item.data));
        this.$message.success("导入成功");
        this.versionManagemenVisible = false;
      });
    },
    async init() {
      // 获取线上的配置文件
      let res = await this.topo.TopoComponents.getPagesCloud();

      if (!res.success) {
        this.$message.error(res.message);
      }

      for await (let item of res.data) {
        item.typeData = await this.getTypeCate(item.typeId);
      }

      this.configList = res.data || [];

    },

    // 获取类型信息执行分类
    async getTypeCate(id) {
      let data = await this.topo.TopoComponents.getType(id);
      return data.data;
    },

    // 载入历史版本
    async loadVersion() {
      let list = await this.topo.getHistoryTopoConfig();
      if (!list) return;
      this.versionList = list;
    },
    // 载入历史记录配置文件
    loadConfigFile(config) {
      this.$alert("是否导入最新记录。这将覆盖当前正在编辑的文件").then(() => {
        this.dialogFormVisible = false;
        this.topo.stageCanvas.open(config);
        this.topo.stageCanvas.inactive();
        this.$message({
          message: "载入成功",
          type: "success",
        });
      });
    },
    // 在页内预览
    previewInPage() {
      this.locked = this.topo.store.data.locked;

      if (!this.locked) {
        this.topo.stageCanvas.lock(2);
        this.$message("已切换预览模式");
      } else {
        this.topo.stageCanvas.lock(0);
        this.$message("已切换编辑模式");
      }
      this.locked = this.topo.store.data.locked;
    },
    preview() {
      this.$Application.run("technology-preview", {
        newWindow: true,
      });
    },
    exportConfig() {
      this.$emit("export");
    },
    importConfig() {
      this.$emit("import");
    },
    changeLineProp(item) {
      this.topo.stageCanvas.drawLine(item.value);
    },
    setLineWidth(line) {
      this.topo.data.lineWidth = line;
    },
    // 下载配置文件
    downloadConfig(configItem) {
      const loading = this.$loading({
        lock: true,
        text: "下载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      DownloadFile(configItem.url)
        .then((text) => {
          let blob = new Blob([text], { type: "text/plain" });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = `${configItem.name}_${configItem.key}_${this.topo.proc.data?.device.deviceNo || "ALLDEVICE"
            }_${Date.now()}.topo`;
          a.click();
          a.remove();
          loading.close();
        })
        .catch((err) => {
          loading.close();
          this.$message.error("下载失败");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}

.config-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #ccc;

  &:hover {
    background: rgba($color: #000000, $alpha: 0.1);
  }

  &:nth-last-child(1) {
    border: none;
  }
}

.line-prop-container {
  display: flex;
}

.menu-item {
  display: flex;
  align-items: center;
  margin-right: 10px;

  .menu-label {
    margin-right: 10px;
    white-space: nowrap;
  }

  .menu-select {
    width: 100px;
    text-align: center;
  }
}

.config-content {
  .list-item {
    display: flex;
    justify-content: space-between;
    padding: 8px 15px;
    border-bottom: 1px solid #eee;
    align-items: center;
    user-select: text;

    &:nth-last-child(1) {
      border: none;
    }

    &:hover {
      background: rgba($color: #000000, $alpha: 0.1);
      border-radius: 5px;
    }

    .left-item-card {
      .time {
        color: #999;

        span {
          margin-right: 15px;
        }
      }
    }
  }
}

.version-item {
  max-height: 500px;
  overflow-y: auto;
}
</style>